export enum TypeCustomer {
  retail,
  perusahaan,
  pelanggan
}
